import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { HistoricoPromocionesService } from 'src/app/services/historico-promociones.service';


@Component({
    selector: 'app-consulta-config',
    templateUrl: './consulta-config.component.html',
    styleUrls: ['./consulta-config.component.css']
})
export class ConsultaConfigComponent implements OnInit {

    public promotionId: number = 0;
    public promotionName: string = '';
    public viewStatus: number = 0;
    public historial: any[] = [];
    public snapshotSeleccionado: any = null;
    public mostrarSnapshot: boolean = false;

    public displayedColumns: string[] = [
        'id', 'descripcion', 'activa', 'usuarioId',
        'fechaCreacion', 'fechaActivacion', 'fechaInactivacion', 'acciones'
    ];

    public dataSource = new MatTableDataSource<any>([]);

    @ViewChild(MatSort, { static: false }) sort: MatSort;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

    constructor(
        private historicoPromocionesService: HistoricoPromocionesService,
        private route: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef

    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.promotionId = params['promotionId'] ? Number(params['promotionId']) : 0;
            this.promotionName = params['promotionName'] ? params['promotionName'] : '';
            if (this.promotionId) {
                this.getHistoricoXPromocionId();
            }
        });
    }

    ngAfterViewInit(): void {
        // ← Asignar sort y paginator una vez que la vista está lista
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    getHistoricoXPromocionId(): void {
        this.viewStatus = 0;
        this.historicoPromocionesService
            .getHistoricoXPromocionId(this.promotionId)
            .subscribe({
                next: (data: any[]) => {
                    this.dataSource.data = data; // ← solo actualizar los datos, no recrear
                    this.viewStatus = 1;

                    // ← Esperar que el DOM renderice el paginator y sort
                    setTimeout(() => {
                        if (this.paginator) this.dataSource.paginator = this.paginator;
                        if (this.sort) this.dataSource.sort = this.sort;
                        this.cdr.detectChanges();
                    }, 0);
                },
                error: (err) => {
                    console.error('Error al cargar historial:', err);
                    this.viewStatus = 1;
                }
            });
    }

    verSnapshot(item: any): void {
        this.historicoPromocionesService
            .getDetalleAuditoria(item.id)
            .subscribe({
                next: (detalle: any) => {
                    try {
                        const snapshot = JSON.parse(detalle.snapshotCompleto);
                        sessionStorage.setItem('snapshot_preview', JSON.stringify(snapshot));
                        this.router.navigate(
                            ['/promociones/configurador-promociones'],
                            { queryParams: { mode: 'snapshot', promotionId: snapshot.promocionId } }
                        );
                    } catch (err) {
                        console.error('Error al parsear snapshot:', err);
                    }
                },
                error: (err) => console.error('Error al cargar snapshot:', err)
            });
    }

    applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
    }

    formatearFecha(fecha: any): string {
        if (!fecha) return '—';
        return new Date(fecha).toLocaleString('es-MX');
    }

    cerrarSnapshot(): void {
        this.snapshotSeleccionado = null;
        this.mostrarSnapshot = false;
    }

    close() {
        this.router.navigateByUrl("/promociones/configurador");
    }
}